module.exports = __webpack_public_path__ + "media/images/gallery/constellations/andromeda/and_figure-736d7d2344e1ebe1b34f409e28ffcde0.gif";